import { Text } from '@wix/design-system';
import React, { useState } from 'react';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { CollectionActionCustomLayoutModal } from '../CollectionActionModal';
import { observer } from 'mobx-react-lite';
import { DataExtensionState, ConditionalModalState } from '@wix/bex-core';

export const _ArchiveFieldModal = ({
  state,
}: {
  state: DataExtensionState;
}) => {
  const container = useWixPatternsContainer();
  const { translate: t } = container;

  const [archiveModalState] = useState(() => {
    state.archiveFieldModal ??= new ConditionalModalState({
      onConfirm: async () => {
        if (!state.archiveFieldModal?.value) {
          return;
        }

        state.biReporter.reportArchiveFieldModalCtaClicked('Archive');
        await state.archiveField(state.archiveFieldModal.value);
      },
      onClose: () => {
        state.biReporter.reportArchiveFieldModalCtaClicked('Cancel');
      },
    });

    return state.archiveFieldModal!;
  });

  return (
    <CollectionActionCustomLayoutModal
      dataHook="archive-custom-field-modal"
      state={archiveModalState}
      title={t('cairo.customFields.archive.modal.title')}
      primaryButtonText={t('cairo.customFields.archive.modal.CTA')}
      secondaryButtonText={t('cairo.customFields.archive.modal.cancel.CTA')}
      content={
        <Text dataHook="archive-custom-field-body">
          {t('cairo.customFields.archive.modal.description')}
        </Text>
      }
      theme="destructive"
      width="510px"
    />
  );
};

export const ArchiveFieldModal = observer(_ArchiveFieldModal);
